import dataBase from '@/dataBase/database'
import { reportService } from '@/_services'
import { config } from '@/_helpers'

export const offlineReportService = {
  //отчет по точке
  async getPointReport(pointId) {
    if (navigator.onLine) {
      let data = await reportService.getReportByPointId(pointId)
      if (data) {
        await dataBase.pointReport.put({
          id:           String(pointId),
          projectId:    String(data.project?.id),
          pointId:      String(pointId),
          comment:      data.comment,
          reportStatus: data.reportStatus,
          createdAt:    data.createDate,
          updatedAt:    data.sendDate,
          cachedAt:     new Date().toISOString(),
          synced:       1,
        })
        if (data.reportPhoto?.length) {
          await dataBase.photos.where('reportId').equals(String(pointId)).delete()
          for (const photo of data.reportPhoto) {
            const response = await fetch(config.image(photo.uuid))
            const blob = await response.blob()
            await dataBase.photos.add({
              reportId: String(pointId),
              reportType: 'point',
              uuid: photo.uuid,
              extension:  photo.extension,
              blob: blob,
              synced: 1,
              dmp: photo.dmp,
              offline: false,
              motivational: photo.motivational,
              createdAt:  new Date().toISOString(),
            })
          }
        } else {
          await dataBase.photos.where('reportId').equals(String(pointId)).delete()
        }
        return data
      } else {
        await dataBase.pointReport.where('pointId').equals(String(pointId)).delete()
      }
    } 
    let report = await dataBase.pointReport.where('pointId').equals(String(pointId)).first()
    if (!report) return null
    let photos = await dataBase.photos.where('reportId').equals(String(pointId)).toArray()
    report.reportPhoto = []
    if(photos.length) {
      for (const photo of photos) {
        report.reportPhoto.push(photo)
      }
    }
    return report
  },

  //сохранение reportData
  async saveReportData(data) {
    if (navigator.onLine) {
      return reportService.sendReportData(data)
    }
    let now = new Date().toISOString()
    let key = `${data.productId}_${data.tradePointId}`
    let photoIds = []
    for (let photo of (data.photos || [])) {
      if (photo.isOffline && photo.blob) {
        let photoId = await dataBase.photos.add({
          reportId: key,
          blob: photo.blob,
          motivational: photo.motivational,
          dmp: photo.dmp || false,
          fileName: photo.name,
          offline: true,
          synced: 0,
          createdAt: now,
        })
        photoIds.push(photoId)
      }
    }
   try {
      await dataBase.productReportData.put({
        id: key,
        productId: String(data.productId),
        pointId: String(data.tradePointId),
        projectId: String(data.projectId),
        photos: photoIds,
        data: {
          ...JSON.parse(JSON.stringify(data.reportItemInfo)),
          comment:  data.comment,
          presense: data.presense,
        },
        synced:   0,
        cachedAt: now,
      })
    } catch(e) {
      console.error('Ошибка put:', e)
    }

    return {
      uuid: `offline_${key}`,
      presense: "V",
      comment: data.comment || '',
      reportFieldData: data.reportItemInfo.reportFieldWithData.map(field => ({
        uuid: field.reportFieldUuid,
        value: field.value,
      })),
      reportPhoto: data.photos || [],
    }
  },

  //сохранение отчёта по точке
  async savePointReport(prereport) {
    if (navigator.onLine) {
      return reportService.sendPreReport(prereport)
    }

    const now = new Date().toISOString()
    const existing = await dataBase.pointReport.where('pointId').equals(String(prereport.tradePointId)).first()
    let reportId

    if (existing) {
      await dataBase.pointReport.update(existing.id, {
        reportStatus: { value: 1, title: 'SEND', name: 'SEND' },
        comment:   prereport.comment,
        updatedAt: now,
        synced:    0,
      })
      reportId = existing.id
    } else {
      reportId = await dataBase.pointReport.add({
        projectId:    String(prereport.projectId),
        pointId:      String(prereport.tradePointId),
        comment:      prereport.comment,
        reportStatus: { value: 1, title: 'SEND', name: 'SEND' },
        createdAt:    now,
        updatedAt:    now,
        synced:       0,
      })
    }
    
    for (let photo of (prereport.tempPhotos || [])) {
      if (photo.isOffline && photo.blob) {
        await dataBase.photos.add({
          reportId:  String(prereport.tradePointId),
          blob: photo.blob,
          dmp: photo.dmp,
          motivational: photo.motivatiional,
          fileName: photo.name,
          offline: true,
          synced: 0,
          createdAt: now,
        })
      }
    }

    return dataBase.pointReport.get(reportId)
  },
}